<template>

  <div :style="{backgroundImage:  `url(${bg})`}" class="bg">
    <div class="overflow"></div>
    <div class="container content">
      <div class="no-players">
        <div class="text">
          <div v-if="positive">
            <transition name="bounce">
              <img class="bounce" src="@/assets/finish.png" alt="" v-if="ready">
            </transition>
            <div class="results" style="margin-top: 50px; padding-bottom: 40px;">
              <div>
                <br>
              </div>
              <p class="red">
                {{ result.payload.points ? result.payload.points.description : "Тест не пройден."}}
              </p>
            </div>
          </div>

          <div v-else>
            <transition name="bounce">
              <img src="@/assets/finish2.png" alt="" v-if="ready">
            </transition>
            <h1 class="center">Программа «{{test.name}}» <br>провалена!
              <span v-if="timeend"><br>Время вышло!</span>
            </h1>
            <div class="results">
              <div>
                <br>
              </div>
              <p class="red">
                {{ result.payload.points ? result.payload.points.description : "Тест не пройден."}}
              </p>
            </div>
          </div>

          <div class="quest">
            <div><label>Какими ещё проблемными ситуациями нужно дополнить систему самоконтроль рисков нарушения антимонопольного законодательства?</label></div>
            <div class="form-group"><textarea></textarea></div>
          </div>

          <div class="buttons">
            <router-link :to="{name: 'Start', params: {slug: orgSlug}}">
              <div class="btn btn-lg">
                Вернуться к списку программ
              </div>
            </router-link>

            <div class="btn btn-lg" @click="restartTest">
              Начать заново
            </div>

            <!-- <div class="btn btn-lg" @click="print">
              Распечатать
            </div> -->
          </div>

        </div>

      </div>
    </div>
    <!--<app-footer></app-footer>-->
  </div>
</template>

<script>
  import Radar from 'vue-radar'
  import TestsService from '@/services/TestsService'

  export default {
    name: 'test-finish',
    props: ['positive', 'score', 'percent', 'minutes', 'timeend'],
    components: {
      'v-radar': Radar
    },
    data () {
      return {
        audioSuccess: new Audio(require('@/assets/music/applause.mp3')),
        result: '',
        ready: false,
        orgSlug: '',
        testId: '',
        radar: {
          structure: {
            external: { // external stroke of the structure's polygon
              strokeColor: 'rgba(0, 0, 0, 1)', // color (any css format is usable (hexa, rgb, rgba...))
              strokeWidth: '4' // pixel unit
            },
            internals: { // internals stroke of the structure's polygon (one every 10%)
              strokeColor: 'rgba(0, 0, 0, .3)', // color (any css format is usable (hexa, rgb, rgba...))
              strokeWidth: '1' // pixel unit
            },
            average: { // average polygon (placed at 50%)
              strokeColor: 'rgba(0, 0, 0, 1)', // stroke color (any css format is usable (hexa, rgb, rgba...))
              strokeWidth: '0', // pixel unit
              fillColor: 'rgba(0, 0, 0, 0)' // polygon color (any css format is usable (hexa, rgb, rgba...))
            }
          },
          lines: { // lines from center to summits
            strokeColor: 'rgba(0, 0, 0, .3)', // color (any css format is usable (hexa, rgb, rgba...))
            strokeWidth: '1' // pixel unit
          }
        },
        scale: {},
        stats: [],
        polycolor: 'rgba(31, 136, 217, .5)'
      }
    },
    mounted () {
      this.ready = true
      this.orgSlug = this.$route.params.slug
      this.testId = this.$route.params.id
      // 90% от максимального кол-ва очков
      if (this.positive && (this.score / this.test.score >= 0.9)) {
        this.audioSuccess.play()
      }

      const vm = this

      let playerId = this.$store.getters.getPlayer.id
      // let resultId = this.$store.getters.resultId
      let orgSlug = this.orgSlug
      TestsService.getTestResultsByPlayerId(orgSlug, playerId).then(
        (response) => {
          TestsService.getTestResultByPlayerIdAndTestIdAndSlug(playerId, response[0].id, orgSlug).then(
            (response) => {
              vm.result = response
              vm.stats = []
            }
          )
        }
      )
    },
    computed: {
      bg () {
        if (this.positive) {
          return require('@/assets/finishgood.jpg')
        } else return require('@/assets/finishbad2.jpg')
      },
      test () {
        return this.$store.getters.test
      }
    },
    methods: {
      restartTest () {
        this.$parent.$emit('restartTest')
      },
      print () {
        window.print()
      },
      scorePoints (score, test) {
        let result = Math.floor(score * 100 / test)
        return result
      }
    }
  }
</script>

<style scoped lang="scss">
  .results {
    background-color: rgba(255,255,255, 0.8);
    width: 100%;
    padding: 1rem 10px;

    p {
      color: rgba(0,0,0, 0.6) !important;
    }
  }

  .bg {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    position: relative;
    .overflow {
      background-color: rgba(0, 0, 0, 0.4);
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }
  }

  .content {
    min-height: 100vh;
  }

  .no-players {
    margin-top: 75px;
    h1 {
      margin: 20px 0;
      color: #fff;
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
    }
    .text {
      color: #000 !important;
      padding: 10vh 5rem;
      @media screen and (max-width: 700px) {
        padding: 0;
      }
      p {
        font-weight: 400;
        color: rgba(255, 255, 255, 0.6);
      }
      p.red {
        margin-top: -15px !important;
      }
      .round {
        display: inline-block;
        font-size: 120%;
        color: rgba(0,0,0, 0.8) !important;
      }
    }
  }

  img {
    display: inline-block;
    margin: 20px 0;
  }

  .blue {
    color: $blue;
  }

  .red {
    color: $red;
  }

  .btn {
    display: block;
    font-size: 18px;
    padding: 15px;
    margin-bottom: 30px;
    box-sizing: border-box;
    width: 300px;
    background-color: #acdae7;
    &:hover {
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
    }
  }

  .buttons {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 20px;
  }

  .v-radar {
    margin-right: 50px;
  }

  .radar {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .groups {
    margin-bottom: 40px;
    ul {
      list-style: none;
      padding: 0;
    }
  }

  .info {
    margin-top: 40px;
    margin-bottom: 50px;
  }

  .stats {
    ul {
      list-style: none;
      line-height: 3em;
      padding: 0;
    }
    .blue {
      color: $blue;
      padding-right: 10px;
      font-size: 0.8em;
    }
    li {
      font-size: 0.8em;
      text-align: left;
      margin: -35px 0;
    }
  }

  @media print {
    .header, .buttons {
      display: none;
    }

    h1.center {
      display: none;
    }

    .btn {
      display: none;
    }

    .results {
      position: absolute;
      top: 0;
      left: 0;

      .radar {
        height: 70vh;

        li {
          margin: 10px 0;
          font-size: 0.7em;
        }
      }

      p.red {
        font-size: 0.9em;
      }
    }

    img.bounce {
      display: none;
    }

    .stats {
      ul {
        list-style: none;
        line-height: 1.5em;
      }
      .blue {
        color: $blue;
        padding-right: 10px;
      }
    }
  }
  .quest {
    margin-top: 30px;
    label {
      color: #fff;
      line-height: 1.5em;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/game/TestFinish.vue